<script>
import { required } from 'vuelidate/lib/validators';
export default {
    name: "RemarksModal",
    props: {
        modalId: {
            type: String,
            default: "remarks-modal",
        },
        title: {
            type: String,
            default: "Return Remarks",
        },
        label: {
            type: String,
            default: "Remarks",
        },
        placeholder: {
            type: String,
            default: "Enter Remarks...",
        },
        btnText: {
            type: String,
            default: "Return",
        },
        btnClass: {
            type: String,
            default: "btn-warning",
        },
        btnIcon: {
            type: String,
            default: "bx bx-reply",
        },
    },
    data() {
        return {
            submitted: false,
            modalTitle: "",
            modalLabel: "",
            modalPlaceholder: "",
            modalBtnText: "",
            modalBtnClass: "",
            modalBtnIcon: "",
            btnLoading: false,
            form: {
                remarks: null,
            },
            extraData: null,
        };
    },
    validations: {
        form: {
            remarks: { required },
        },
    },
    created() {
        this.resetOptions();
    },
    methods: {
        resetOptions() {
            this.modalTitle = this.title;
            this.modalLabel = this.label;
            this.modalPlaceholder = this.placeholder;
            this.modalBtnText = this.btnText;
            this.modalBtnClass = this.btnClass;
            this.modalBtnIcon = this.btnIcon;
            this.btnLoading = false;
            this.extraData = null;
        },
        resetForm() {
            this.submitted = false;
            this.btnLoading = false;
            this.form.remarks = null;
            if (this.$v) {
                this.$v.$reset();
            }
        },
        open(options = {}) {
            this.resetForm();
            this.modalTitle = options.title || this.title;
            this.modalLabel = options.label || this.label;
            this.modalPlaceholder = options.placeholder || this.placeholder;
            this.modalBtnText = options.btnText || this.btnText;
            this.modalBtnClass = options.btnClass || this.btnClass;
            this.modalBtnIcon = options.btnIcon !== undefined ? options.btnIcon : this.btnIcon;
            this.btnLoading = false;
            this.extraData = options.data || null;
            this.$bvModal.show(this.modalId);
        },
        hide() {
            this.$bvModal.hide(this.modalId);
        },
        setLoading(val) {
            this.btnLoading = !!val;
        },
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            let data = JSON.parse(JSON.stringify(this.form));
            this.$emit('submit', data.remarks, this.extraData);
        },
    }
};
</script>
<template>
    <b-modal
        :id="modalId"
        :title="modalTitle || title"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        @hidden="resetForm"
    >
        <form @submit.prevent="onCreate" class="needs-validation">
            <div class="mb-3">
                <label for="remarks">{{ modalLabel || label }}</label>
                <b-form-textarea
                    id="remarks"
                    v-model="form.remarks"
                    :placeholder="modalPlaceholder || placeholder"
                    rows="3"
                    autocomplete="off"
                    :class="{
                        'is-invalid': submitted && $v.form.remarks.$error,
                    }"
                />
                <div
                    v-if="submitted && $v.form.remarks.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.form.remarks.required">This field is required.</span>
                </div>
            </div>
            <hr />
            <div class="text-end">
                <button type="submit" class="btn" :class="modalBtnClass || btnClass" :disabled="btnLoading">
                    <b-spinner v-if="btnLoading" small class="me-1"></b-spinner>
                    <i :class="`${modalBtnIcon || btnIcon} me-1`" v-else-if="modalBtnIcon || btnIcon"></i>
                    {{ modalBtnText || btnText }}
                </button>
                <button
                    type="button"
                    class="btn btn-link ms-2"
                    :disabled="btnLoading"
                    @click="$bvModal.hide(modalId)"
                >
                    Cancel
                </button>
            </div>
        </form>
    </b-modal>
</template>